var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"auth-blitz-frame",attrs:{"src":_vm.src,"title":_vm.title,"sandbox":"allow-scripts allow-forms allow-popups allow-same-origin allow-top-navigation-by-user-activation"}})}
var staticRenderFns = []

export { render, staticRenderFns }